<template>
  <section>
    <draggable v-model="modifiersStore" @change="orderChanged">
      <v-flex v-for="(modifier, index) in modifiersStore" :key="index">
        <v-flex xs12 md12 py-1>
          <v-card>
            <v-row align="center">
              <v-flex py-1 pl-3 xs2 md2 class="grey--text text--darken-1">
                <v-layout justify="center">
                  <h4>{{ modifier.name }}</h4>
                </v-layout>
              </v-flex>
              <v-divider class="mx-3" vertical></v-divider>
              <v-flex
                xs4
                md4
                v-html="getTriggers(modifier)"
                class="caption grey--text text--darken-2"
              ></v-flex>
              <v-divider class="mx-3" vertical></v-divider>
              <v-flex xs3 md3 class="caption grey--text text--darken-2" pt-1 pb-1>
                Base Fare: {{modifier.base_fare}}
                <br />
                Per Mile Fare: {{modifier.per_mile_fare}}
                <br />
                Per Minute Fare: {{modifier.per_minute_fare}}
                <br />
                Additional Charge: {{modifier.additional_charge}}
                <br />
              </v-flex>
              <v-flex xs2 md2 pr-3>
                <v-layout justify-end>
                  <v-card-actions>
                    <v-btn icon ripple @click="edit(index)">
                      <v-icon color="grey lighten-1">edit</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-layout>
              </v-flex>
            </v-row>
          </v-card>
        </v-flex>
      </v-flex>
    </draggable>
    <v-flex v-if="modifiers.length == 0" xs12 md12 pl-1>
      <div class="grey--text text--darken-1">None</div>
    </v-flex>
  </section>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "tariff_modifier_list",
  components: {
    draggable
  },
  props: {
    modifiers: Array
  },
  data: function() {
    return {
      modifiersStore: []
    };
  },
  beforeMount: async function() {
    this.modifiersStore = this.modifiers;
  },
  methods: {
    getTriggers: function(modifier) {
      let triggerText = "";

      let triggerDays = "";
      if (modifier.monday) {
        triggerDays += "Monday";
      }
      if (modifier.tuesday) {
        triggerDays == ""
          ? (triggerDays += "Tuesday")
          : (triggerDays += ", Tuesday");
      }
      if (modifier.wednesday) {
        triggerDays == ""
          ? (triggerDays += "Wednesday")
          : (triggerDays += ", Wednesday");
      }
      if (modifier.thursday) {
        triggerDays == ""
          ? (triggerDays += "Thursday")
          : (triggerDays += ", Thursday");
      }
      if (modifier.friday) {
        triggerDays == ""
          ? (triggerDays += "Friday")
          : (triggerDays += ", Friday");
      }
      if (modifier.saturday) {
        triggerDays == ""
          ? (triggerDays += "Saturday")
          : (triggerDays += ", Saturday");
      }
      if (modifier.sunday) {
        triggerDays == ""
          ? (triggerDays += "Sunday")
          : (triggerDays += ", Sunday");
      }

      if (triggerDays != "") {
        triggerText += triggerDays + "<br>";
      }

      if (modifier.bank_holiday != null && modifier.bank_holiday != "") {
        triggerText += "Bank Holiday" + "<br>";
      }

      if (
        modifier.hour_period_start != null &&
        modifier.hour_period_start != "" &&
        modifier.hour_period_end != null &&
        modifier.hour_period_end != ""
      ) {
        let triggerHourPeriod =
          modifier.hour_period_start + " to " + modifier.hour_period_end;
        triggerText += triggerHourPeriod + "<br>";
      }

      if (
        modifier.day_period_start_date != null &&
        modifier.day_period_start_date != "" &&
        modifier.day_period_end_date != null &&
        modifier.day_period_end_date != ""
      ) {
        let triggerDayPeriod =
          modifier.day_period_start_date +
          "/" +
          modifier.day_period_start_month +
          " " +
          modifier.day_period_start_time +
          " to " +
          modifier.day_period_end_date +
          "/" +
          modifier.day_period_end_month +
          " " +
          modifier.day_period_end_time;

        triggerText += triggerDayPeriod + "<br>";
      }

      return triggerText;
    },
    edit: function(index) {
      this.$emit("edit", index);
    },
    orderChanged: function() {
      this.$emit("orderChange", this.modifiersStore);
    }
  },
  watch: {
    modifiers: function() {
      this.modifiersStore = this.modifiers;
    }
  }
};
</script>
